function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #959595;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "informatica",
  transform: "translate(-540.69 -328.228)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_98",
  "data-name": "Grupo 98"
}, /*#__PURE__*/React.createElement("path", {
  id: "Trazado_51",
  "data-name": "Trazado 51",
  className: "cls-1",
  d: "M572.862,328.228H543.614a2.928,2.928,0,0,0-2.924,2.925v20.473a2.928,2.928,0,0,0,2.924,2.925h10.24c-.03,1.167-.253,3.033-1.09,3.914a1.435,1.435,0,0,1-1.107.473.732.732,0,0,0,0,1.463h13.162a.732.732,0,0,0,0-1.463,1.432,1.432,0,0,1-1.1-.472c-.835-.877-1.059-2.746-1.091-3.915h10.239a2.928,2.928,0,0,0,2.925-2.925V331.153A2.928,2.928,0,0,0,572.862,328.228Zm-14.624,24.865a1.467,1.467,0,1,1,1.467-1.467A1.468,1.468,0,0,1,558.238,353.093ZM543.614,348.7V331.153h29.248V348.7Z"
})));

function SvgInformatica(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.097,
    height: 32.173,
    viewBox: "0 0 35.097 32.173",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformatica);
export default __webpack_public_path__ + "static/media/informatica.7846018a.svg";
export { ForwardRef as ReactComponent };